import request from '@/plugin/axios'
export function getUser(id) {
    return request({
        url: '/user/' + id,
        method: 'get',
        loading: {
            type: 'nprogress',
            interval: 500
        }
    })
}
export function getUserPermissionInfo(data) {
    return request({
        url: '/moblieapp/user',
        method: 'post',
        data
    })
}
export function getUserPagedList(query) {
    return request({
        url: '/moblieapp/userPagedlist',
        method: 'post',
        params: query
    })
}

export function getUserStaffPagedList(query) {
    return request({
        url: '/moblieapp/userStaffPagedlist',
        method: 'post',
        params: query
    })
}
export function editRoleUser(data) {
    return request({
        url: '/moblieapp/editroleuser',
        method: 'post',
        data: data
    })
}
export function saveUser(data) {
    return request({
        url: '/moblieapp/userSave',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}

export function saveUserStore(data) {
    return request({
        url: '/moblieapp/userStoreSave',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}


export function saveStoreQrcode(data) {
    return request({
        url: '/moblieapp/storeQrcodeSave',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}

export function getCheckUser(data) {
    return request({
        url: '/moblieapp/checkUser',
        method: 'post',
        data: data,
        loading: {
            type: 'nprogress',
            interval: 500
        }
    })
}
export function delUser(data) {
    return request({
        url: '/moblieapp/userDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}
export function delUsers(ids) {
    return request({
        url: '/moblieapp/batchuserdel',
        method: 'post',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}